<template><!--帮助说明-->
  <div>
    <el-carousel :height="bannerHeight+'px'">
      <el-carousel-item v-for="item in imgList" :key="item.id">
        <img ref="bannerHeight" :src="item.img" alt="" height="auto" width="100%" @click="goToBigImg(item.bigImg)"/>
      </el-carousel-item>
    </el-carousel>

    <el-row class="group">
      <el-col :span="6">
        <div class="title">
          <i class="el-icon-user-solid grid-content-i"></i>
          <div>关于账户</div>
        </div>
      </el-col>
      <el-col :span="18">
        <div class="content">
          <div v-for="data in aboutAccount" @click="goToRouter(data.title)">{{ data.title }}</div>
        </div>
      </el-col>
    </el-row>

    <el-row class="group">
      <el-col :span="6">
        <div class="title">
          <i class="el-icon-chat-dot-round grid-content-i"></i>
          <div>聊天相关</div>
        </div>
      </el-col>

      <el-col :span="18">
        <!--男-->
        <div v-if="sex === '1'" class="content">
          <div v-for="data in ChatRelatedMan" @click="goToRouter(data.title)">{{ data.title }}</div>
        </div>

        <!--女-->
        <div v-if="sex === '2'" class="content">
          <div v-for="data in ChatRelatedGirl" @click="goToRouter(data.title)">{{ data.title }}</div>
        </div>
      </el-col>
    </el-row>

    <el-row class="group">
      <el-col :span="6">
        <div class="title">
          <i class="el-icon-s-home grid-content-i"></i>
          <div>平台规则</div>
        </div>
      </el-col>

      <el-col :span="18">
        <!--男-->
        <div v-if="sex === '1'" class="content">
          <div v-for="data in RulesPlatformMan" @click="goToRouter(data.title)">{{ data.title }}</div>
        </div>

        <!--女-->
        <div v-if="sex === '2'" class="content">
          <div v-for="data in RulesPlatformGirl" @click="goToRouter(data.title)">{{ data.title }}</div>
        </div>
      </el-col>
    </el-row>

  </div>
</template>

<script>
export default {
  data() {
    return {
      bannerHeight: '',
      imgList: [
        {id: 0, img: require('@/assets/img/净网公约_横.png'), bigImg: require('@/assets/img/净网公约_竖.png')},
        {id: 1, img: require('@/assets/img/净网公约_横.png'), bigImg: require('@/assets/img/净网公约_竖.png')}
      ],

      activeName: '1',

      sex: this.$route.query.sex,//  性别: 1男 2女
      //  关于账户
      aboutAccount: [
        {title: "修改信息"},
        {title: "用户个人页异常"},
        {title: "登录方式"},
        {title: "认证相关"}
      ],

      //  聊天相关_男
      ChatRelatedMan: [
        {title: "聊天消耗什么"},
        {title: "如何免费聊天"},
        {title: "机器脚本/导流/广告等聊天举报"},
        {title: "应用内消息提醒设置"},
        {title: "离线消息提醒设置"}
      ],
      //  聊天相关_女
      ChatRelatedGirl: [
        {title: "聊天可以得到金币，金币可以提现"},
        {title: "为什么聊天偶尔没有收益"},
        {title: "机器脚本/导流/广告等聊天举报"},
        {title: "如何让他人找到我"},
        {title: "提现与到账时间"},
        {title: "应用内消息提醒设置"},
        {title: "离线消息提醒设置"},
      ],

      //  平台规则_男
      RulesPlatformMan: [
        {title: "禁止第三平台"},
        {title: "哪些情况会被封禁"},
        {title: "被封禁的账号会怎么样"},
        {title: "封禁时间"},
      ],
      //  平台规则_女
      RulesPlatformGirl: [
        {title: "禁止第三平台"},
        {title: "哪些情况会被封禁"},
        {title: "被封禁的账号会怎么样?"},
        {title: "封禁时间"},
      ]
    }
  },
  methods: {
    //  跳转路由
    goToRouter(title) {
      this.$router.push({path: '/agreement/helptextDetails', query: {title: title}});
    },
    //  跳转路由
    goToBigImg(bigImg) {
      this.$router.push({path: '/agreement/helptextBigImg', query: {bigImg: bigImg}});
    },
  },
  mounted() {
    this.bannerHeight = document.documentElement.clientWidth / 3.6;

    window.onresize = () => {
      return (() => {
        this.bannerHeight = this.$refs.bannerHeight[0].height;
      })();
    };
  },
  created() {

  }
}
</script>
<style>

.group_title {
  padding: 10px;
  border: 1px solid #EBEEF5;
}

.group {
  border: 1px solid #EBEEF5;
  margin-top: -1px;
}

.title {
  text-align: center;
}

.grid-content-i {
  padding-top: 10px;
  margin-bottom: 10px;
  font-size: 30px;
}

.content {
  margin-bottom: -1px;
}

.content div {
  padding: 10px 5px;
  border: 1px solid #EBEEF5;
  margin-top: -1px;
}
</style>
